import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rnpl-page-card',
  templateUrl: './page-card.component.html',
  styleUrls: ['./page-card.component.scss']
})
export class PageCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
